import {
	ShiftPurpose,
	ShiftPurposeDetailField,
} from "../components/gat-admin/store/gat-admin-slice-types";

/**
 * Length limit applied to a new question's answers. The server owns this and
 * returns it as `detailField.maxLength` — always prefer the value that came
 * back with the purpose, and use this only when configuring a brand new one.
 */
export const SHIFT_PURPOSE_DETAIL_DEFAULT_MAX_LENGTH = 360;

/**
 * Shift Purposes to offer while posting or editing a Shift, keyed by id.
 */
export const getShiftPurposeOptions = (
	shiftPurposes: Record<string, ShiftPurpose> | undefined
): Record<string, ShiftPurpose> => shiftPurposes ?? {};

/**
 * The free-text detail the selected Shift Purpose asks for, as configured in GAT
 * Admin — e.g. the purpose "Overtime" asks for a "Cost centre". Null when the
 * purpose asks for nothing, which is the case for most of them.
 */
export const getShiftPurposeDetailField = (
	shiftPurposes: Record<string, ShiftPurpose> | undefined,
	shiftPurposeId: number | string
): ShiftPurposeDetailField | null => {
	if (!shiftPurposeId) return null;
	return shiftPurposes?.[`${shiftPurposeId}`]?.detailField ?? null;
};
